import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/components/HomeView.vue'
import Result from '@/components/ResultView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/result/:id',
    name: 'Result',
    component: Result,
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
